import type { ViewportConfettiOptions } from '@/utils/confetti/viewportConfetti'

const yellowWhiteConfettiColors = [
  '#FFFFFF',
  '#FFFEF5',
  '#FFF9E6',
  '#FFEB3B',
  '#FFD54F',
  '#FFC107',
  '#FFB300',
]

export const bookingSuccessConfettiPreset: ViewportConfettiOptions = {
  particleCount: 20,
  spread: 70,
  startVelocity: 38,
  ticks: 260,
  gravity: 1.05,
  scalar: 1.05,
  colors: yellowWhiteConfettiColors,
  followUp: {
    delayMs: 140,
    particleCount: 55,
    angle: 60,
    spread: 60,
    colors: yellowWhiteConfettiColors,
  },
}
